import projectsDataNoType from "../assets/projectsData.json";
import { redirect, LoaderFunctionArgs } from "react-router-dom";

type ImgData = {
	url: string;
	webp?: { [key: string]: string };
	jpg?: { [key: string]: string };
	png?: { [key: string]: string };
	alt: string;
};
type MetaData = {
	date: string;
	role: string[];
	tools: string[];
	link: string;
};
type ProcessData = {
	design: string[];
	dev: string[];
	challenges: string[];
};
export type ProjectData = {
	id: number;
	tags: string[];
	title: string;
	subtitle: string;
	slug: string;
	img: ImgData;
	logo?: ImgData;
	meta?: MetaData;
	description: string;
	goal?: string;
	process?: ProcessData;
	result?: string;
	next?: string;
};

const projectsData = projectsDataNoType as ProjectData[];

export const getAllProjects = async () => projectsData;

export const getProjectByTag = async ({ params }: LoaderFunctionArgs) =>
	projectsData.filter(project => project.tags.includes(params.tag));

export const projectLoader = async ({ params }: LoaderFunctionArgs) => {
	const project = projectsData.find(project => params.projectName === project.slug);

	if (project) return project;

	// TODO : Error message "Sorry this project doesn't exist"
	return redirect("/work");
};

export const defaultProject = {
	id: 0,
	tags: [],
	title: "The fail project",
	slug: "the--fail-project",
	img: {
		alt: "No image here",
	},
	description: "Well... Seems there is a problem (please reload the page)",
};
